import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import logger from '../../utils/logger';
import { MLRadioContext } from './MLRadio';

const MLRadioButtonGroup = ({
  children,
  name,
  className,
  testId,
  onChange,
  defaultSelected,
  selectedValue,
  labelId,
}) => {
  const [currentSelectedValue, setCurrentSelectedValue] = useState(
    selectedValue || defaultSelected,
  );

  useEffect(() => {
    if (selectedValue !== currentSelectedValue && selectedValue) {
      setCurrentSelectedValue(selectedValue);
    }
  }, [selectedValue, currentSelectedValue]);

  const handleChildChange = (e, value) => {
    setCurrentSelectedValue(value);
    onChange(e, value);
  };

  if (currentSelectedValue) {
    const found = findIndex(
      children,
      (child) => child.props && currentSelectedValue === child.props.value,
    );
    if (found < 0) {
      logger(
        'Error => the set value on MLRadioButton Group does not match any child',
      );
      return null;
    }
  }

  const contextValue = {
    selectedValue: currentSelectedValue,
    onChange: handleChildChange,
  };

  return (
    <div role="radiogroup" aria-labelledby={labelId}>
      <form name={name} className={className} data-test-id={testId}>
        <MLRadioContext.Provider value={contextValue}>
          {children}
        </MLRadioContext.Provider>
      </form>
    </div>
  );
};

MLRadioButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
  onChange: PropTypes.func,
  defaultSelected: PropTypes.any,
  selectedValue: PropTypes.any,
};

export default MLRadioButtonGroup;
